/* eslint-disable react/style-prop-object */
import { useState } from "react";
import ChartItem from "./ChartItem/ChartItem";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import VehicleStatusModal from "./VehicleStatusModal";

export default function DashboardChartNumbers({ data, isLoading, isError }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleChartClick = (statusKey) => {
    setSelectedStatus(statusKey);
    setShowModal(true);
  };

  const getNumber = (key) => {
    return isLoading ? <Skeleton width={50} /> : data?.data[key];
  };

  const chartItems = [
    { title: "Running", style: "green dots", key: "running" },
    { title: "idle", style: "orange dots", key: "idle" },
    { title: "Stopped", style: "brown dots", key: "stopped" },
    { title: "No data", style: "grey dots", key: "noData" },
    { title: "Online", style: "blue dots", key: "online" },
    { title: "Unknown", style: "purple dots", key: "unknown" },
    { title: "Offline", style: "tomato dots", key: "offline" },
    {
      title: "In Maintenance",
      style: "gray-300 dots",
      key: null,
      number: "NA",
    },
  ];

  const renderChartItems = (items) =>
    items.map((item, idx) => (
      <ChartItem
        key={item.title}
        title={item.title}
        number={item.number ?? getNumber(item.key)}
        style={item.style}
        margin={idx !== 0 ? "mt-16" : ""}
        onClick={() => item.key && handleChartClick(item.key)}
      />
    ));

  if (isError) {
    return (
      <div className="mt-24 row">
        <div className="col-lg-6 col-md-6">
          {renderChartItems(
            chartItems.slice(0, 4).map((i) => ({ ...i, number: 0 }))
          )}
        </div>
        <div className="col-lg-6 col-md-6">
          {renderChartItems(
            chartItems.slice(4, 8).map((i) => ({ ...i, number: 0 }))
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="mt-24 row">
        <div className="col-lg-6 cursor">
          {renderChartItems(chartItems.slice(0, 4))}
        </div>
        <div className="col-lg-6 cursor">
          {renderChartItems(chartItems.slice(4, 8))}
        </div>
      </div>

      <VehicleStatusModal
        show={showModal}
        onHide={() => setShowModal(false)}
        status={selectedStatus}
      />
    </>
  );
}
